import { observer } from 'mobx-react-lite'
import moment from 'moment'

import { dmsState } from '@/app/store'
import { type IInsuredContract } from '@/app/types/dmsTypes'

import style from './InsuredPrograms.module.scss'
import { ProgramContracts } from './ProgramContracts/ProgramContracts'

interface IProps {
    type: string
    companyId: string
}

const onSeparateContracts = (contracts: IInsuredContract[]): [IInsuredContract[], IInsuredContract[]] => {
    const currentDate = moment()

    const firstPart: IInsuredContract[] = contracts.filter(
        (c) => moment(c.conclusionAt).isBefore(currentDate) && moment(c.finishedAt).isSameOrAfter(currentDate)
    )

    const secondPart: IInsuredContract[] = contracts.filter(
        (c) => !(moment(c.conclusionAt).isBefore(currentDate) && moment(c.finishedAt).isSameOrAfter(currentDate))
    )

    return [firstPart, secondPart]
}

export const InsuredPrograms = observer((props: IProps) => {
    const { type, companyId } = props

    if (!dmsState.chosenInsured) {
        return null
    }

    const currentContracts: IInsuredContract[] = dmsState.chosenInsured[type].contracts

    if (currentContracts.length < 1 && type === 'edit') {
        return <div className={style.empty}>Договоры отсутствуют</div>
    }

    const topContracts = onSeparateContracts(currentContracts)[0]
    const bottomContracts = onSeparateContracts(currentContracts)[1]

    return (
        <div className={style.container}>
            <ProgramContracts contracts={topContracts} companyId={companyId} />
            <ProgramContracts contracts={bottomContracts} companyId={companyId} />
        </div>
    )
})
